import { AxiosInstance } from "axios";
import { ResetPasswordPayload } from "../types/resetPassword";

export async function resetPassword(api: AxiosInstance, payload: ResetPasswordPayload) {
  return await api.post("api/users/v1/users/reset_password/", payload);
}
